// src/App.js

import "./App.css";
import "/node_modules/primeflex/primeflex.css";
import "primeflex/primeflex.css";
import "primeflex/primeflex.scss";
import { Route, Routes, Navigate, Link, useNavigate } from "react-router-dom";
import MainNavigation from "./components/MainNavigation";
import Footer from "./components/Footer";
import { useLocation } from "react-router-dom";
import NotFound from "./components/NotFound";
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import HomePage from "./pages/HomePage";
import DashboardPage from "./pages/DashboardPage";
import RegisterLogin from "./pages/RegisterLogin";
import 'primereact/resources/themes/lara-light-indigo/theme.css'; 
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import ManagerDashboardPage from "./pages/ManagerDashboardPage";
import EditArticle from "./components/EditArticle";
import Weblog from "./pages/WeblogPage";
import { setupAxiosInterceptors, useAxiosInterceptors } from "./apiClient";
import { useOnlineStatus } from "./context/OnlineContext";
import { Toast } from "primereact/toast";
import ErrorBoundary from "./components/ErrorBoundary";
import colors from './colors.js';
import NewArticle from "./components/NewArticle.js";
import SiteWeblog from "./pages/SiteWeblog.js";

function App() {

  const location = useLocation();
  let user = JSON.parse(localStorage.getItem('seo_app') != null) ? JSON.parse(localStorage.getItem('seo_app')) : { name: "" };
  const token = JSON.parse(localStorage.getItem('userToken'));
  const config = { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } };
  const { online, setOnline } = useOnlineStatus();
  const [theme, setTheme] = useState();
  const loginType = [0, 1];
  const navigate = useNavigate();
  const toast = useRef(null);

  //function to show session expiration toast:
  const showExpirationToast = (message) => {
    toast.current.show({ severity: 'error', summary: message });
  };

  //injecting colors in css:
  useEffect(() => {


        
    
    const root = document.documentElement;
    root.style.setProperty('--primary-color', colors.primary);
    root.style.setProperty('--secondary-color', colors.secondary);
    root.style.setProperty('--text-color', colors.text);
    root.style.setProperty('--whitesmoke_background-color', colors.whitesmoke_background);
    
  }, []);


  //fetching theme:
  useEffect(() => {
    const fetchTheme = async () => {
      await axios
        .get(process.env.REACT_APP_BACK + "/settings/theme/" + user._id, config)
        .then((result) => {
          if (result.status === 200) {
            if (result.data) setTheme(result.data);
            else setTheme("light");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    setupAxiosInterceptors(navigate, setOnline, showExpirationToast);

    if (user?._id) fetchTheme();
    else setTheme("light");
  }, []);

  return (
    <div className={theme + " App"}>
      
      <ErrorBoundary>

        <Toast ref={toast} position="center"></Toast>

         <MainNavigation online={online} user={user} /> 

        {theme ? (
          <Routes>
            <Route exact path="/" element={<HomePage />} />
            <Route exact path="/dashboard" element={online ? <DashboardPage type="dashboard" theme={theme} /> : <RegisterLogin />} />
            <Route exact path="/dashboard/articles" element={online ? <DashboardPage type="articles" theme={theme} /> : <RegisterLogin />} />
            <Route exact path="/dashboard/watermark" element={online ? <DashboardPage type="watermark" theme={theme} /> : <RegisterLogin />} />
            <Route exact path="/dashboard/account" element={online ? <DashboardPage type="account" theme={theme} /> : <RegisterLogin />} />
            <Route exact path="/dashboard/plans" element={online ? <DashboardPage type="plans" theme={theme} /> : <RegisterLogin />} />
            <Route exact path="/manager-dashboard/orders" element={online ? <ManagerDashboardPage type="orders" theme={theme} /> : <RegisterLogin />} />
            <Route exact path="/manager-dashboard" element={online ? <ManagerDashboardPage type="dashboard" theme={theme} /> : <RegisterLogin />} />
            <Route exact path="/manager-dashboard/users" element={online ? <ManagerDashboardPage type="users" theme={theme} /> : <RegisterLogin />} />
            <Route exact path="/manager-dashboard/weblog" element={online ? <ManagerDashboardPage type="weblog" theme={theme} /> : <RegisterLogin />} />
            <Route exact path="/manager-dashboard/articles" element={online ? <ManagerDashboardPage type="articles" theme={theme} /> : <RegisterLogin />} />
            <Route exact path="/edit-article" element={online ? <EditArticle /> : <RegisterLogin />} />
            <Route exact path="/articles/:user_id/:article_slug" element={<Weblog singleArticle={true} setTheme={setTheme} theme={theme} />} />
            <Route exact path="/new-article" element={<NewArticle/>}></Route>
            <Route exact path="/weblog/:article_slug" element={<SiteWeblog singleArticle={true} setTheme={setTheme} theme={theme}/>} />
            <Route exact path="/weblog" element={<SiteWeblog singleArticle={false}></SiteWeblog>}></Route>
            <Route exact path="/weblog/page/:page" element={<SiteWeblog singleArticle={false}></SiteWeblog>}></Route>
            <Route exact path="/login" element={<RegisterLogin type={loginType[0]} />} />
            <Route exact path="/register" element={<RegisterLogin type={loginType[1]} />} />
            <Route exact path="/404" element={<NotFound />} />
            <Route path="*" element={<Navigate to="/404" />} />
          </Routes>
        ) : null}

        {location.pathname === "/" || location.pathname === "*" || !online ? <Footer /> : null}
      </ErrorBoundary>
    </div>
  );
}

export default App;
